import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/App";

const LINKS = [
  { label: "Power Gains", href: "#vehicle-selector" },
  { label: "Services", href: "#stages" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const scrollTo = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -70, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Header = ({ onBook }) => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };

  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 bg-asphalt/85 backdrop-blur-xl border-b border-[#1F232D]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[70px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="bm solutions logo"
            className="h-11 w-11 object-cover rounded-full ring-1 ring-[#262933] group-hover:ring-nitro transition-colors duration-300"
          />
          <span className="font-heading font-bold text-2xl tracking-wide uppercase leading-none">
            bm <span className="text-nitro">solutions</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => go(e, l.href)}
              className="font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-nitro transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            data-testid="header-book-cta"
            onClick={onBook}
            className="hidden sm:inline-flex bg-nitro hover:bg-[#ff4561] text-white font-heading font-semibold uppercase tracking-wider rounded-full px-6 transition-all duration-300 hover:shadow-[0_0_25px_rgba(255,46,77,0.45)]"
          >
            Book Remap
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-neutral-300 hover:text-nitro transition-colors"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-panel border-t border-[#1F232D] px-6 py-5 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="font-mono text-xs tracking-[0.2em] uppercase text-neutral-300 hover:text-nitro transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="mobile-book-cta"
            onClick={() => {
              setOpen(false);
              onBook();
            }}
            className="bg-nitro hover:bg-[#ff4561] text-white font-heading uppercase tracking-wider rounded-full"
          >
            Book Remap
          </Button>
        </motion.div>
      )}
    </motion.header>
  );
};
